module.exports = __webpack_public_path__ + "static/media/nestje2.799e5b05.jpg";